// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumbs{font-size:14px;line-height:18px;color:#aaabae;margin-bottom:14px}.breadcrumbs li{display:inline-block;vertical-align:top}.breadcrumbs li:after{content:\"—\";display:inline-block;vertical-align:middle;margin-left:13px;margin-right:12px}.breadcrumbs li:last-child:after{display:none}.breadcrumbs li.current-breadcrumb{color:#262e39;pointer-events:none}@media screen and (max-width:1200px){.breadcrumbs{margin-bottom:14px}}", ""]);
// Exports
module.exports = exports;
